import { configureStore } from '@reduxjs/toolkit'
import { withReduxConfigs } from 'utils'

import dataReducer from './data'
import infiniteScrollReducer from './infiniteScroll'

import mapApi from '~map-search/services/map'
import tagApi from '~map-search/services/tag'

const createStore = (initialState) => {
  return configureStore(
    withReduxConfigs({
      reducer: {
        infiniteScroll: infiniteScrollReducer,
        data: dataReducer,
        [mapApi.reducerPath]: mapApi.reducer,
        [tagApi.reducerPath]: tagApi.reducer
      },
      middleware: (getDefaultMiddleware) => {
        return getDefaultMiddleware().concat([
          mapApi.middleware,
          tagApi.middleware
        ])
      },
      preloadedState: prepInitialState(initialState)
    })
  )
}

const prepInitialState = (initialState) => {
  const { userGeolocation } = initialState

  const data = {
    userGeolocation
  }

  return {
    data
  }
}

export { createStore }
